import { render, staticRenderFns } from "./AddContactPerson.vue?vue&type=template&id=a0acb50a&"
import script from "./AddContactPerson.vue?vue&type=script&lang=ts&"
export * from "./AddContactPerson.vue?vue&type=script&lang=ts&"
import style0 from "./AddContactPerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports